<template>
    <div class="w-full min-h-screen bg-gray-200 md:py-8">





        <div class="container mx-auto bg-white  md:p-8 rounded-lg shadow-lg">

            <div class="w-full md:flex px-8 pt-8 md:pt-0 md:px-0">
                <div class="flex-1">
                    <h1 class="font-bold text-4xl ">Schedule for {{ restaurant.name }}</h1>

                </div>

                <div>

                    <a :href="backurl" class="inline-flex items-center px-4 py-2 border border-gray-600 shadow-sm text-base font-medium rounded-md text-gray-700 ">

                        Cancel
                    </a>

                    <button @click="save" type="button" class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Save
                    </button>

                </div>

            </div>

        </div>


        <div v-for="(day, dayindex) in days" :key="dayindex" class="container mx-auto bg-white mt-8 md:p-8 rounded-lg shadow-lg">
            <div class="font-bold text-lg mb-2">{{ day }}</div>

            <div v-if="timeline[dayindex].length === 0" class="text-center italic">
                Férmé
            </div>
            
            <div v-for="(group, groupindex) in timeline[dayindex]" :key="`g${dayindex}-${group[0]}`" class="flex justify-end my-2">
                <div class="w-2/3 flex items-center">
                    <div>
                        <template v-if="edit_day===dayindex&&edit_group===groupindex">
                            <select v-model="editing[0]" class="">
                                <option v-for="h in start" :value="h.value">
                                    {{ h.label }}
                                </option>
                            </select>
                        </template>
                        <template v-else>
                            {{ hour(group[0]) }}
                        </template>
                    </div>
                    <div class="flex-1 h-0.5 bg-gray-400 mx-8 relative">
                        <div class="absolute top-0 left-0 -mt-1 -ml-1 w-2 h-2 rounded-full bg-gray-400"></div>
                        <div class="absolute top-0 right-0 -mt-1 -mr-1 w-2 h-2 rounded-full bg-gray-400"></div>
                    </div>
                    <div>
                        <template v-if="edit_day===dayindex&&edit_group===groupindex">
                            <select v-model="editing[1]" class="">
                                <option v-for="h in end" :value="h.value">
                                    {{ h.label }}
                                </option>
                            </select>
                        </template>
                        <template v-else>
                            {{ hour(group[1]) }}
                        </template>
                    </div>
                </div>

                <template v-if="edit_day===dayindex&&edit_group===groupindex">
                    <div class="cursor-pointer ml-4" @click="done">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                    </div>
                </template>
                <template v-else-if="edit_day===-1&&edit_group===-1">
                    <div class="cursor-pointer ml-4" @click="edit(dayindex, groupindex)">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                        </svg>
                    </div>

                    <div class="cursor-pointer ml-4" @click="remove(dayindex, groupindex)">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                    </div>



                </template>

            </div>

            <div class="text-right">
                <div class="inline-flex items-center mt-4 cursor-pointer " @click="add(dayindex)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
                    </svg>
                    
                    Ajouter</div>
            </div>

        </div>

        
    </div>
</template>

<script>

export default {
    name: "MerchantTimeline",
    components: {},
    props: [
        'id', 'restaurant', 'backurl', 'saveurl'
    ],
    data() {
        return {
            grabbing: false,
            days: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
            
            edit_day: -1,
            edit_group: -1,
            
            editing: null,
            backup: null,
            adding: -1,
            timeline: this.restaurant.timeline.map(line => this.lineToGroups(line)),
        }
    },

    computed: {
        start() {
            let hours = [];
            if (!this.editing) return hours;
            for (let i = 0; i < 48 && ((1*this.editing[1]) === -1 || i < (1*this.editing[1])); i++) {
                hours.push({value: i, label: this.hour(i)});
            }
            return hours;
        },
        end() {
            let hours = [];

            if (!this.editing) return hours;
            for (let i = (1*this.editing[0]) === -1 ? 0 : (1*this.editing[0]) + 1; i < 48; i++) {
                hours.push({value: i, label: this.hour(i)});
            }
            return hours;
        },
    },

    methods: {
        save() {
            this.$inertia.post(this.saveurl, {
                timeline: this.restaurant.timeline
            });
        },

        add(day) {
            this.timeline[day].push([-1,-1]);
            this.edit(day, this.timeline[day].length -1);
        },
        
        edit(day, groupindex) {
            this.editing = this.timeline[day][groupindex];
            this.edit_day = day;
            this.edit_group = groupindex;
        },
        
        remove(day, groupindex) {
            this.timeline[day].splice(groupindex, 1);
            this.rebuildDay(day);
        },

        done() {
            this.rebuildDay(this.edit_day);
            
            this.editing = null;
            this.edit_day = -1;
            this.edit_group = -1;
            
        },

        rebuildDay(day) {
            let t = [];
            for (let i = 0; i < 48; i++) {
                t.push(false);
            }
            this.timeline[day].forEach(group => {
                for (let i = (1*group[0]); i < (1*group[1]); i++) {
                    t[i] = true;
                }
            });
            
            this.restaurant.timeline[day] = t;
            this.timeline.splice(day, 1, this.lineToGroups(t));
            
        },

        lineToGroups(line) {
            let groups = [];
            let group = [-1, -1];
            let open = false;
            for (let i in line) {
                if (line[i] !== open) {
                    if (open) { // we close
                        group[1] = i;
                        groups.push(group);
                        group = [-1, -1];
                    } else { // we open
                        group[0] = i;
                    }
                    open = line[i];
                }
            }
            return groups;
        },

        hour(index) {
            let minutes = index * 30;
            let hours = Math.floor(minutes / 60);
            minutes = minutes % 60;
            if (minutes < 10) {
                minutes = '0'+ minutes;
            }
            return `${hours}:${minutes}`;
        }

    }
}
</script>

<style scoped>

</style>
